"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = void 0;
const regex_1 = require("../../constants/regex");
const is_string_1 = require("../is-string/is-string");
/**
 * Returns true if the string is a valid email
 * @public
 
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is a valid name or not.
 *
 * @example
 * ```ts
 * const result = isValidEmail('qa@healthcare.com');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidEmail(arg) {
    return (0, is_string_1.isString)(arg) && regex_1.EMAIL_REGEX.test(arg);
}
exports.isValidEmail = isValidEmail;
//# sourceMappingURL=is-valid-email.js.map